import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Products from "./components/Products";
import About from "./components/About";
import Stats from "./components/Stats";
import Contact from "./components/Enquiry";
import WhatsApp from "./components/WhatsApp";
import useScrollReveal from "./hooks/useScrollReveal";
import Footer from "./components/Footer";
function App() {
  useScrollReveal();

  return (
    <div>
      <Navbar />
      <Hero />
      <Products />
      <About />
      <Stats />
      <Contact />
      <WhatsApp />
      <Footer />
    </div>
  );
}

export default App;